@use "variables" as *;

.interconnectionCell {
  display: flex;
  align-items: flex-start;
}

.interconnectionIcon {
  flex-shrink: 0;
  margin-right: $spacing-1;
}

.interconnectionText {
  text-indent: 0;
}
